'use client'

import { ReactNode } from 'react'

interface IConfigAppContainerProps {
  children: ReactNode
}

const ConfigAppContainer: React.FC<IConfigAppContainerProps> = ({
  children,
}) => {
  return <>{children}</>
}

export default ConfigAppContainer
